module.exports = __webpack_public_path__ + "static/media/website-design.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/website-design.svg
// module id = 515
// module chunks = 0